/** Канал межвкладочного оповещения о выходе, канал и сообщение — как в sportexam-front и Checkup. */
export const LOGOUT_CHANNEL = 'prss-frontchannel-logout';

export const LOGOUT_MESSAGE_TYPE = 'logout';
